<template>
	<div>
		<a-modal title="订单详情" :width="800" :visible="visible"  @cancel="handleCancel" >
			<template slot="footer" v-if="order.status==1 || order.status==2">
				<a-button  key="back"  @click="cancelAppointAct" :loading="cancelAppointLoading">
					取消订单
				</a-button>
				<!-- <a-button  key="submit" type="primary" @click="sureAppointAct" :loading="sureAppointLoading">
					确认预约
				</a-button> -->
			</template>
			<template slot="footer">
				<a-button  key="back"  @click="handleCancel" >
					关闭弹窗
				</a-button>
			</template>

			<div class="item">
				<!-- <div class="flex space">
					<div v-if="item.status==1"><a-button type="primary" icon="plus" @click="editAppointmentAct(item)">修改</a-button></div>
				</div> -->
				<a-divider />
				<a-spin :spinning="loading">
					<div class="pt24 pb24">
						<div class="flex alcenter space">
							<div class="flex alcenter">
								<img :src="order.course_cover_img" class="order-detail-project-cover-img"/>
								<div class="ml10">
									<div class="flex alcenter">
										<div class="ft14 ftw400 cl-black">{{order.course_name}}</div>
										<div class="order-detail-status-on ml8" v-if="order.status==1 || order.status==2 || order.status==3">{{order.status_means}}</div>
										<div class="order-detail-status-off ml8" v-if="order.status==4">{{order.status_means}}</div>
									</div>
								</div>
							</div>
							
							<div class="flex alcenter">
								<div>课程时间：</div>
								<div class="flex alcenter ft14 ftwblod">
									<!-- <div class="cl-black">{{order.day}}</div> -->
									<div class="cl-theme ml4">{{order.start_time}} - {{order.end_time}}</div>
								</div>
							</div>
							
						</div>
					</div>
					
					<a-divider />
					
					<div class="pt24 pb24">
						<div class="flex space">
							<div>
								<div class="flex alcenter">
									<div class="ft14 ftw400 cl-info">订单编号：</div>
									<div class="ft14 ftwblod cl-black">{{order.order_id}}</div>
								</div>
								<div class="flex alcenter mt15">
									<div class="ft14 ftw400 cl-info">下单时间：</div>
									<div class="ft14 ftwblod cl-black">{{order.add_time_format}}</div>
								</div>
								<div class="flex alcenter mt15">
									<div class="ft14 ftw400 cl-info">实际总价：</div>
									<div class="ft14 ftwblod cl-black">{{order.real_price}}</div>
								</div>
							</div>
							
							<div>
								<div class="flex alcenter">
									<div class="ft14 ftw400 cl-info">预约用户：</div>
									<div class="ft14 ftwblod cl-black">{{order.member.member_name}}</div>
								</div>
								<div class="flex alcenter mt15">
									<div class="ft14 ftw400 cl-info">手机号码：</div>
									<div class="ft14 ftwblod cl-black">{{order.member.member_mobile}}</div>
								</div>
								<!-- <div class="flex alcenter mt15">
									<div class="ft14 ftw400 cl-info">折扣：</div>
									<div class="ft14 ftwblod cl-black">{{order.discount}}</div>
								</div> -->
							</div>
							
							<!-- <div>
								<div class="flex alcenter">
									<div class="ft14 ftw400 cl-info">预约技师：</div>
									<div class="ft14 ftwblod cl-black">{{item.technician_name}}</div>
								</div>
								<div class="flex alcenter mt15">
									<div class="ft14 ftw400 cl-info">手机号码：</div>
									<div class="ft14 ftwblod cl-black">{{item.technician_mobile}}</div>
								</div>
								<div class="flex alcenter mt15">
									<div class="ft14 ftw400 cl-info">实价：</div>
									<div class="ft14 ftwblod cl-black">{{Number(item.current_price * item.discount).toFixed(2)}}</div>
								</div>
							</div> -->
						</div>
					</div>
				
					<a-divider v-if="order.status==3" />
					
					<div class="pt24 pb24"  v-if="order.status==3">
						<div>
							<div class="flex alcenter">
								<div class="ft14 ftw400 cl-info">核销时间：</div>
								<div class="ft14 ftwblod cl-black">{{order.verification_time_format}}</div>
							</div>
							<div class="flex alcenter mt15">
								<div class="ft14 ftw400 cl-info">操作人员：</div>
								<div class="ft14 ftwblod cl-black">{{order.operate_name}} {{order.operate_mobile}}</div>
							</div>
						</div>
					</div>
					
					<a-divider v-if="order.status==4" />
					
					<div class="pt24 pb24"  v-if="order.status==4">
						<div>
							<div class="flex alcenter">
								<div class="ft14 ftw400 cl-info">取消时间：</div>
								<div class="ft14 ftwblod cl-black">{{order.cancel_time_format}}</div>
							</div>
							<div class="flex alcenter mt15">
								<div class="ft14 ftw400 cl-info">操作人员：</div>
								<div class="ft14 ftwblod cl-black"> {{order.operate_name}} {{order.operate_mobile}}</div>
							</div>
							<div class="flex alcenter mt15">
								<div class="ft14 ftw400 cl-info">取消原因：</div>
								<div class="ft14 ftwblod cl-black">{{order.reason}}</div>
							</div>
						</div>
					</div>

					<a-divider />

				</a-spin>
			</div>
		</a-modal>

		<!-- 取消预约（父单） -->
		<div v-if="cancelAppointVisible">
			<cancel-appoint :order_id="order.order_id" :visible="cancelAppointVisible" @cancel="cancelCancelAppoint" @ok="okCancelAppoint"></cancel-appoint>
		</div>

		<!-- 预约修改 -->
		<div v-if="editAppointmentVisible">
			<edit-appointment :visible="editAppointmentVisible" @cancel="cancelEditAppointment" @ok="okEditAppointment" :item="editItem"></edit-appointment>
		</div>
	</div>
</template>

<script>
	import cancelAppoint from './detail/modal/cancelAppoint.vue';
	import editAppointment from './editAppointment.vue';
	export default {
		props: {
			visible:{
				type:Boolean,
				default:false,
			},
			order:{
				type:Object,
				default:function(){
					return new Object;
				},
			}
		},
		components:{
			cancelAppoint,
			editAppointment
		},
		data() {
			return {
				loading: false,
				cancelAppointLoading:false,
				sureAppointLoading:false,
				sureWriteOffLoading:false,
				cancelAppointVisible:false,
				shuangWriteOffLoading:false,
				editAppointmentVisible:false,
				editItem:{}
			}
		},
		created() {
			console.log(this.order)
		},
		methods: {

			// 取消预约（父单）
			cancelAppointAct(){
				this.cancelAppointVisible=true;
			},
			cancelCancelAppoint(){
				this.cancelAppointVisible=false;
			},
			okCancelAppoint(){
				this.cancelAppointVisible=false;
				this.$emit('cancelAppoint')
			},

			getAppointmentDetail(id){
				this.$http.api('admin/getAppointmentDetail',{
					appointment_id:this.order.appointment_id,
				}).then(res=>{
					this.$message.success('操作成功',1,()=>{
						console.log('res.data.detail',res)
						this.order = res.detail
					});
					
				}).catch(res=>{
					console.log(res);
				})
			},

			//确认预约（父单）
			sureAppointAct(){
				if(this.sureAppointLoading==true) return;
				this.sureAppointLoading=true;
				this.$http.api('admin/sureAppointment',{
					appointment_id:this.order.appointment_id,
				}).then(res=>{
					this.$message.success('操作成功',1,()=>{
						this.sureAppointLoading=false;
						this.$emit('sureAppoint')
					});
					
				}).catch(res=>{
					console.log(res);
					this.sureAppointLoading=false;
				})
			},
			
			//确认到店（父单）
			sureWriteOffAct(){
				if(this.sureWriteOffLoading==true) return;
				this.sureWriteOffLoading=true;
				this.$http.api('admin/arrivalAppointment',{
					appointment_id:this.order.appointment_id,
				}).then(res=>{
					this.$message.success('操作成功',1,()=>{
						this.sureWriteOffLoading=false;
						this.$emit('sureWriteOff')
					});
					
				}).catch(res=>{
					console.log(res);
					this.sureWriteOffLoading=false;
				})
			},

			//确认到店项（子单）
			sureWriteOffActItem(item_id){
				// 显示确认弹框
				this.$confirm({
					title: '确认到店',
					content: '确定要将此预约标记为已到店吗？',
					okText: '确认',
					cancelText: '取消',
					type: 'warning',
					onOk: () => {
						// 用户点击确认后执行的操作
						this.$http.api('admin/arrivalAppointmentItem',{
							appointment_item_id:item_id,
						}).then(res=>{
							this.$message.success('操作成功',1,()=>{
								
								// 重新获取订单数据
								this.getAppointmentDetail();
							});
							
						}).catch(res=>{
							console.log(res);
						})
					},
					onCancel: () => {
						// 用户点击取消，什么都不做
						console.log('用户取消操作');
					}
				});
			},

			// 已爽约（子单）
			shuangWriteOffActItem(item_id){
				// 显示确认弹框
				this.$confirm({
					title: '确认已爽约',
					content: '确定要将此预约标记为已爽约吗？',
					okText: '确认',
					cancelText: '取消',
					type: 'warning',
					onOk: () => {
						// 用户点击确认后执行的操作
						this.$http.api('admin/shuangAppointmentItem',{
							appointment_item_id:item_id,
						}).then(res=>{
							this.$message.success('操作成功',1,()=>{
								
								// 重新获取订单数据
								this.getAppointmentDetail();
							});
							
						}).catch(res=>{
							console.log(res);
						})
					},
					onCancel: () => {
						// 用户点击取消，什么都不做
						console.log('用户取消操作');
					}
				});
			},
			
			/**
			 * 取消弹窗
			 */
			handleCancel() {
				this.$emit("cancel");
			},

			// 预约修改
			editAppointmentAct(item){
				this.editItem = item
				this.editAppointmentVisible=true;
			},
			cancelEditAppointment(){
				this.editAppointmentVisible=false;
			},
			okEditAppointment(){
				this.editAppointmentVisible=false;
				// 重新获取订单数据
				this.getAppointmentDetail();
			},
	
		}
	}
</script>

<style>
	
	.order-detail-project-cover-img{
		width: 80px;
		height: 60px;
	}
	
	.order-detail-status-on{
		padding: 3px 8px;
		border-radius: 2px;
		border: 1px solid #4772FF;
		font-size: 14px;
		font-weight: 600;
		color: #4772FF;
	}
	
	.order-detail-status-off{
		padding: 3px 8px;
		border-radius: 2px;
		border: 1px solid #EBEDF5;
		font-size: 14px;
		font-weight: 600;
		color: #A6AEC2;
	}

	.item {
		margin-bottom: 30px;
		padding: 15px;
		border: 1px solid #999;   /* 很浅的灰色#e0e0e0 中等灰色#999 深灰色#666 */
	
	}

	.item_button {
		margin-right: 15px;
	}
</style>
